// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2axJn","gfeWrapper":"CalendarEvent_gfeWrapper__3blFX"};